import { runInInjectionContext } from '@angular/core'
import { AngularFireDatabase } from '@angular/fire/compat/database'

for (const method of ['list', 'object', 'createPushId'] as const) {
  const original: (...args: unknown[]) => unknown = AngularFireDatabase.prototype[method]
  AngularFireDatabase.prototype[method] = function (this: AngularFireDatabase, ...args: unknown[]) {
    return runInInjectionContext(this['injector'], () => original.apply(this, args))
  } as never
}
